/**
 * @generated SignedSource<<c3bf98dc6d8f4f4117470e8344fec263>>
 * @relayHash d9a50c42bd4eb5ed009db6000aba2ac3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44b73680cb37925a01797244c9097d033e589ecf159e0e9d8efce0662d88e552

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useAIAgentStreamingDataBulkIssueADFQuery$variables = {
  contentId: string;
};
export type useAIAgentStreamingDataBulkIssueADFQuery$data = {
  readonly singleContent: {
    readonly body: {
      readonly atlas_doc_format: {
        readonly value: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useAIAgentStreamingDataBulkIssueADFQuery = {
  response: useAIAgentStreamingDataBulkIssueADFQuery$data;
  variables: useAIAgentStreamingDataBulkIssueADFQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentBody",
            "kind": "LinkedField",
            "name": "atlas_doc_format",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAIAgentStreamingDataBulkIssueADFQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAIAgentStreamingDataBulkIssueADFQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d9a50c42bd4eb5ed009db6000aba2ac3",
    "id": "44b73680cb37925a01797244c9097d033e589ecf159e0e9d8efce0662d88e552",
    "metadata": {},
    "name": "useAIAgentStreamingDataBulkIssueADFQuery",
    "operationKind": "query",
    "text": "query useAIAgentStreamingDataBulkIssueADFQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{value}}}}"
  }
};
})();

(node as any).hash = "4db4ab1be0ce872d643140ef39690974";

export default node;
